import React from 'react';
import { ApertureIcon, AsteriskIcon, WavesIcon } from 'lucide-react';
export function LogoMark({
  mark
}: {
  mark: string;
}) {
  if (mark === 'dot') {
    return <span aria-hidden="true" className="h-[0.75em] w-[0.75em] shrink-0 rounded-full bg-fg" data-id="element-229" data-mp="1wpf9ogroz9k2" />;
  }
  if (mark === 'aperture') return <ApertureIcon aria-hidden="true" className="h-[0.9em] w-[0.9em] shrink-0" strokeWidth={2.5} data-id="element-230" data-mp="25sgaq31paagv" />;
  if (mark === 'waves') return <WavesIcon aria-hidden="true" className="h-[0.9em] w-[0.9em] shrink-0" strokeWidth={2.5} data-id="element-231" data-mp="2kg1cntmua3n7" />;
  if (mark === 'asterisk') return <AsteriskIcon aria-hidden="true" className="h-[0.9em] w-[0.9em] shrink-0" strokeWidth={3} data-id="element-232" data-mp="2fhrgpgtaiz0j" />;
  return null;
}